import type { TSelector } from "../i18n/types";

interface DashboardLink {
  name: TSelector;
  href: string;
  subTitle: TSelector;
}

export const DASHBOARD_LINKS: DashboardLink[] =
  localStorage.channel === "walmart" ?
    [
      {
        name: ($) => $.common.dashboardLinks["Merchandising Dashboard"],
        href: "/user/dashboard",
        subTitle: ($) => $.common.dashboardLinks["Overview"],
      },
      {
        name: ($) => $.common.dashboardLinks["Advertising Dashboard"],
        href: "/user/advertising/dashboard",
        subTitle: ($) => $.common.dashboardLinks["Placement"],
      },
    ]
  : [
      {
        name: ($) => $.common.dashboardLinks["Merchandising Dashboard"],
        href: "/user/dashboard",
        subTitle: ($) => $.common.dashboardLinks["Overview"],
      },
      {
        name: ($) => $.common.dashboardLinks["Advertising Dashboard"],
        href: "/user/advertising/dashboard",
        subTitle: ($) => $.common.dashboardLinks["Placement"],
      },
      {
        name: ($) => $.common.dashboardLinks["Goals Dashboard"],
        href: "/user/goals",
        subTitle: ($) => $.common.dashboardLinks["Placement"],
      },
      {
        name: ($) => $.common.dashboardLinks["Pricing Dashboard"],
        href: "/user/pricing/dashboard",
        subTitle: ($) => $.common.dashboardLinks["Pricing"],
      },
      {
        name: ($) => $.common.dashboardLinks["Deals Dashboard"],
        href: "/user/merchandising/promotions",
        subTitle: ($) => $.common.dashboardLinks["Promotions"],
      },
      {
        name: ($) => $.common.dashboardLinks["Content Dashboard"],
        href: "/user/content/quality/org",
        subTitle: ($) => $.common.dashboardLinks["Product"],
      },
    ];

interface ReportLink {
  name: TSelector;
  href: string;
}

export const REPORT_LINKS: ReportLink[] = [
  { name: ($) => $.common.dashboardLinks["Product Report"], href: "/user/report/product" },
  { name: ($) => $.common.dashboardLinks["Product Ad Report"], href: "/user/report/product_ad" },
  { name: ($) => $.common.dashboardLinks["Advertisement Report"], href: "/user/report/advertisement" },
  { name: ($) => $.common.dashboardLinks["Pricing Plan Report"], href: "/user/report/pricing_plan" },
  { name: ($) => $.common.dashboardLinks["Target Report"], href: "/user/report/target" },
];

interface BreadcrumbSpec {
  name: TSelector;
  href: string;
  subTitle?: TSelector;
}

export const AGENCY_DASHBOARD_BREADCRUMB_SPEC: BreadcrumbSpec = {
  name: ($) => $.common.dashboardLinks["Agency Dashboard"],
  href: `/user/agency/dashboard`,
};

export const STAFF_DASHBOARD_BREADCRUMB_SPEC: BreadcrumbSpec = {
  name: ($) => $.common.dashboardLinks["All Customers Dashboard"],
  href: `/user/staff/dashboard`,
};

export const ORG_SUMMARY_REPORT_BREADCRUMB_SPEC: BreadcrumbSpec = {
  name: ($) => $.common.dashboardLinks["Organization Summary Report"],
  href: "/user/report/organization/summary",
};

export const DSP_DASHBOARD_BREADCRUMB_SPEC: BreadcrumbSpec = {
  name: ($) => $.common.dashboardLinks["DSP Dashboard"],
  href: "/user/dsp",
  subTitle: ($) => $.common.dashboardLinks["Placement"],
};
